import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      slider: this.el.querySelector('.swiper-container'),
      slides: this.el.querySelectorAll('.swiper-slide'),
      wrapper: this.el.querySelector('.swiper-wrapper')
    };
    this.isMobile = window.matchMedia('(max-width: 1025px)').matches;
    if (this.el.dataset.experienceEditor === 'true') {
      this.el.style.visibility = 'visible';
      return this.el.classList.add('experience-editor-slider');
    }

    this.sliderSpeed = parseInt(this.el.dataset.sliderSpeed);
    this.draggable = this.el.dataset.draggable === 'true' ? true : false;
    this.initComponent();
  }

  addListeners() {}

  initComponent() {
    if (this.dom.slides.length === 1) {
      for (let index = 0; index < 6; index++) {
        this.dom.wrapper.innerHTML += this.dom.slides[0].outerHTML;
      }
    }
    if (this.dom.slides.length === 2) {
      for (let index = 0; index < 3; index++) {
        this.dom.wrapper.innerHTML += this.dom.slides[0].outerHTML;
        this.dom.wrapper.innerHTML += this.dom.slides[1].outerHTML;
      }
    }

    if (this.dom.slides.length === 3) {
      for (let index = 0; index < 2; index++) {
        this.dom.wrapper.innerHTML += this.dom.slides[0].outerHTML;
        this.dom.wrapper.innerHTML += this.dom.slides[1].outerHTML;
        this.dom.wrapper.innerHTML += this.dom.slides[2].outerHTML;
      }
    }
    if (this.dom.slides.length === 4) {
      for (let index = 0; index < 1; index++) {
        this.dom.wrapper.innerHTML += this.dom.slides[0].outerHTML;
        this.dom.wrapper.innerHTML += this.dom.slides[1].outerHTML;
        this.dom.wrapper.innerHTML += this.dom.slides[2].outerHTML;
        this.dom.wrapper.innerHTML += this.dom.slides[3].outerHTML;
      }
    }

    if (this.dom.slides.length === 5) {
      for (let index = 0; index < 1; index++) {
        this.dom.wrapper.innerHTML += this.dom.slides[0].outerHTML;
        this.dom.wrapper.innerHTML += this.dom.slides[1].outerHTML;
        this.dom.wrapper.innerHTML += this.dom.slides[2].outerHTML;
        this.dom.wrapper.innerHTML += this.dom.slides[3].outerHTML;
        this.dom.wrapper.innerHTML += this.dom.slides[4].outerHTML;
      }
    }
    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this.dom.slider, {
      slidesPerView: 2,
      spaceBetween: 30,
      loop: true,
      allowTouchMove: this.draggable,
      autoHeight: false,
      autoplay: {
        delay: 0,
        pauseOnMouseEnter: false,
        disableOnInteraction: false
      },
      speed: this.sliderSpeed || 18000,
      breakpoints: {
        677: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1025: {
          slidesPerView: 6,
          spaceBetween: 60
        },
        1600: {
          slidesPerView: 6,
          spaceBetween: 130
        }
      }
    });

    this.el.style.visibility = 'visible';
  }
}

export default Module;
